export default __webpack_public_path__ + "static/text-bottom-black-20f87bd434db444eb70d78a88823d25d.svg";